/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReviewYourPeersIcon = /*#__PURE__*/ createSvgIcon(
  'ReviewYourPeersIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.968 14.783c1.003.73 1.532 1.826 1.532 3.217a.5.5 0 01-.5.5h-3.73v-1h3.2c-.105-.848-.488-1.47-1.09-1.908-.74-.539-1.87-.842-3.38-.842v-1c1.62 0 2.99.322 3.968 1.033zM4.206 13.193a.5.5 0 01.46.006 4.65 4.65 0 004.388 0 .5.5 0 01.461-.005 4.447 4.447 0 011.869 1.724c.51.859.826 2.015.826 3.582h-1c0-1.433-.289-2.402-.686-3.07a3.4 3.4 0 00-1.242-1.226 5.65 5.65 0 01-4.845 0 3.366 3.366 0 00-1.25 1.212c-.398.662-.687 1.63-.687 3.084h-1c0-1.586.316-2.743.829-3.598.515-.86 1.204-1.373 1.877-1.71zM14.14 8.93a1.32 1.32 0 100 2.64 1.32 1.32 0 000-2.64zm-2.32 1.32a2.32 2.32 0 114.64 0 2.32 2.32 0 01-4.64 0zM6.86 7.46a1.93 1.93 0 100 3.86 1.93 1.93 0 000-3.86zM3.93 9.39a2.93 2.93 0 115.86 0 2.93 2.93 0 01-5.86 0zM9.109 1.757l-2.09 3.491-2.257-1.513.556-.83 1.383.927 1.55-2.589.858.514zM16.389 3.247l-2.09 3.48-2.256-1.5.554-.833 1.384.92 1.55-2.581.858.514z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ReviewYourPeersIcon;
